import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { useFetchCatalogItems } from 'entities/CatalogItem/lib/useFetchCatalogItems';
import { useFetchCategories } from 'entities/Category/lib/useFetchCategories';
import { getSelectedCategoryIdToFetch } from 'entities/Category/model/selectors/categorySelectors';
import { getCanAddMarketplaceItemsToOrder } from 'entities/Order/model/selectors/ordersPermissions';
import { getSearchCatalogItemIsActive } from 'features/SearchCatalogItems/model/selectors/searchCatalogItemsSelectors';
import { getRouteOrdersAddItemsCategories } from 'shared/const/router';
import {
    PropertyCatalog,
    PropertyCatalogItemsMoveTo,
} from 'widgets/PropertyCatalog';
import { SearchCatalogItems } from 'widgets/SearchCatalogItems';

export const OrderMarketplacePage = () => {
    const location = useLocation();

    const canAddMarketplaceItems = useSelector(
        getCanAddMarketplaceItemsToOrder,
    );
    const isActive = useSelector(getSearchCatalogItemIsActive);
    const selectedCategoryId = useSelector(getSelectedCategoryIdToFetch);

    const { onFetchGlobalCategories } = useFetchCategories();
    const { onFetchCatalogItems } = useFetchCatalogItems();

    useEffect(() => {
        if (!canAddMarketplaceItems) {
            return;
        }

        onFetchGlobalCategories();
    }, [canAddMarketplaceItems, onFetchGlobalCategories]);

    useEffect(() => {
        if (!canAddMarketplaceItems) {
            return;
        }

        if (selectedCategoryId) {
            onFetchCatalogItems(true);
        }
    }, [canAddMarketplaceItems, selectedCategoryId, onFetchCatalogItems]);

    if (!canAddMarketplaceItems) {
        return (
            <Navigate
                to={getRouteOrdersAddItemsCategories()}
                state={location.state}
                replace
            />
        );
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                height: '100%',
            }}
        >
            <Box
                sx={{
                    marginBottom: isActive ? 0 : '16px',
                    ...(isActive
                        ? {
                              display: 'flex',
                              flexDirection: 'column',
                              flex: 1,
                              minHeight: 0,
                          }
                        : { flexShrink: 0 }),
                }}
            >
                <SearchCatalogItems
                    mode="global"
                    moveTo={PropertyCatalogItemsMoveTo.ORDER}
                    expandable
                />
            </Box>

            {!isActive ? (
                <Box
                    sx={{
                        display: 'flex',
                        overflow: 'hidden',
                        flex: 1,
                        minHeight: 0,
                    }}
                >
                    <PropertyCatalog
                        isEditing
                        moveTo={PropertyCatalogItemsMoveTo.ORDER}
                    />
                </Box>
            ) : null}
        </Box>
    );
};
